export var VaiIcon;
(function (VaiIcon) {
    VaiIcon["AccessPoint"] = "access-point";
    VaiIcon["Airport"] = "airport";
    VaiIcon["AlertAlarm"] = "alert-alarm";
    VaiIcon["AlertBell"] = "alert-bell";
    VaiIcon["AlertBellOff"] = "alert-bell-off";
    VaiIcon["AlertInfo"] = "alert-info";
    VaiIcon["AlertOk"] = "alert-ok";
    VaiIcon["AlertWarning"] = "alert-warning";
    VaiIcon["Altitude"] = "altitude";
    VaiIcon["AppSwitcher"] = "app-switcher";
    VaiIcon["ArrowDown"] = "arrow-down";
    VaiIcon["ArrowLeft"] = "arrow-left";
    VaiIcon["ArrowRight"] = "arrow-right";
    VaiIcon["ArrowUp"] = "arrow-up";
    VaiIcon["ArrowUpAndDown"] = "arrow-up-and-down";
    VaiIcon["Attachment"] = "attachment";
    VaiIcon["Autosonde"] = "autosonde";
    VaiIcon["Aws"] = "aws";
    VaiIcon["Battery0"] = "battery-0";
    VaiIcon["Battery1"] = "battery-1";
    VaiIcon["Battery2"] = "battery-2";
    VaiIcon["Battery3"] = "battery-3";
    VaiIcon["Battery4"] = "battery-4";
    VaiIcon["Building"] = "building";
    VaiIcon["Calendar"] = "calendar";
    VaiIcon["CapsLock"] = "caps-lock";
    VaiIcon["Car"] = "car";
    VaiIcon["CenterMap"] = "center-map";
    VaiIcon["Check"] = "check";
    VaiIcon["CheckboxChecked"] = "checkbox-checked";
    VaiIcon["CheckboxPartially"] = "checkbox-partially";
    VaiIcon["CheckboxUnchecked"] = "checkbox-unchecked";
    VaiIcon["ChevronDown"] = "chevron-down";
    VaiIcon["ChevronLeft"] = "chevron-left";
    VaiIcon["ChevronRight"] = "chevron-right";
    VaiIcon["ChevronUp"] = "chevron-up";
    VaiIcon["Circle"] = "circle";
    VaiIcon["CircleO"] = "circle-o";
    VaiIcon["City"] = "city";
    VaiIcon["Clock"] = "clock";
    VaiIcon["Cloud"] = "cloud";
    VaiIcon["CloudData"] = "cloud-data";
    VaiIcon["CloudO"] = "cloud-o";
    VaiIcon["CloudSun"] = "cloud-sun";
    VaiIcon["Co2CarbonDioxide"] = "co2-carbon-dioxide";
    VaiIcon["Communication"] = "communication";
    VaiIcon["CommunicationFailure"] = "communication-failure";
    VaiIcon["Connection"] = "connection";
    VaiIcon["ConnectionFailure"] = "connection-failure";
    VaiIcon["Contrast"] = "contrast";
    VaiIcon["Copy"] = "copy";
    VaiIcon["Cross"] = "cross";
    VaiIcon["Cut"] = "cut";
    VaiIcon["Cyclone"] = "cyclone";
    VaiIcon["DataLogger"] = "data-logger";
    VaiIcon["DewPoint"] = "dew-point";
    VaiIcon["Diamond"] = "diamond";
    VaiIcon["DiamondO"] = "diamond-o";
    VaiIcon["Disabled"] = "disabled";
    VaiIcon["Document"] = "document";
    VaiIcon["DocumentDoc"] = "document-doc";
    VaiIcon["DocumentExcel"] = "document-excel";
    VaiIcon["DocumentImg"] = "document-img";
    VaiIcon["DocumentLog"] = "document-log";
    VaiIcon["DocumentMov"] = "document-mov";
    VaiIcon["DocumentPdf"] = "document-pdf";
    VaiIcon["DocumentPpt"] = "document-ppt";
    VaiIcon["DocumentTxt"] = "document-txt";
    VaiIcon["DocumentWav"] = "document-wav";
    VaiIcon["DoubleChevronDown"] = "double-chevron-down";
    VaiIcon["DoubleChevronLeft"] = "double-chevron-left";
    VaiIcon["DoubleChevronRight"] = "double-chevron-right";
    VaiIcon["DoubleChevronUp"] = "double-chevron-up";
    VaiIcon["Download"] = "download";
    VaiIcon["DragHorizontal"] = "drag-horizontal";
    VaiIcon["DragVertical"] = "drag-vertical";
    VaiIcon["DragZoom"] = "drag-zoom";
    VaiIcon["Drop"] = "drop";
    VaiIcon["Dust"] = "dust";
    VaiIcon["Edit"] = "edit";
    VaiIcon["EllipsesHorizontal"] = "ellipses-horizontal";
    VaiIcon["EllipsesVertical"] = "ellipses-vertical";
    VaiIcon["Email"] = "email";
    VaiIcon["EnergyOff"] = "energy-off";
    VaiIcon["EnergyOn"] = "energy-on";
    VaiIcon["Ethernet"] = "ethernet";
    VaiIcon["Exclamation"] = "exclamation";
    VaiIcon["Error"] = "error";
    VaiIcon["FastForward"] = "fast-forward";
    VaiIcon["Filter"] = "filter";
    VaiIcon["FilterSwitches"] = "filter-switches";
    VaiIcon["Fire"] = "fire";
    VaiIcon["Flood"] = "flood";
    VaiIcon["Floorplan"] = "floorplan";
    VaiIcon["Fog"] = "fog";
    VaiIcon["Folder"] = "folder";
    VaiIcon["FolderOpen"] = "folder-open";
    VaiIcon["FullScreen"] = "full-screen";
    VaiIcon["GenericDevice"] = "generic-device";
    VaiIcon["Globe"] = "globe";
    VaiIcon["Graph"] = "graph";
    VaiIcon["H2O2HydrogenPeroxide"] = "h2o2-hydrogen-peroxide";
    VaiIcon["Hail"] = "hail";
    VaiIcon["Heartbeat"] = "heartbeat";
    VaiIcon["Heat"] = "heat";
    VaiIcon["Help"] = "help";
    VaiIcon["HelpO"] = "help-o";
    VaiIcon["Home"] = "home";
    VaiIcon["Humidity"] = "humidity";
    VaiIcon["Key"] = "key";
    VaiIcon["Language"] = "language";
    VaiIcon["Laptop"] = "laptop";
    VaiIcon["Layers"] = "layers";
    VaiIcon["LayersMarker"] = "layers-marker";
    VaiIcon["Lightning"] = "lightning";
    VaiIcon["Link"] = "link";
    VaiIcon["LinkNewWindow"] = "link-new-window";
    VaiIcon["List"] = "list";
    VaiIcon["Lock"] = "lock";
    VaiIcon["Login"] = "login";
    VaiIcon["Logout"] = "logout";
    VaiIcon["MapMarker"] = "map-marker";
    VaiIcon["MapMarkerHexagon"] = "map-marker-hexagon";
    VaiIcon["MapMarkerInterest"] = "map-marker-interest";
    VaiIcon["MapMarkerSquare"] = "map-marker-square";
    VaiIcon["Marine"] = "marine";
    VaiIcon["Maximize"] = "maximize";
    VaiIcon["MeasureStick"] = "measure-stick";
    VaiIcon["Minimize"] = "minimize";
    VaiIcon["Minus"] = "minus";
    VaiIcon["MissingValue"] = "missing-value";
    VaiIcon["MobileMenu"] = "mobile-menu";
    VaiIcon["Monitor"] = "monitor";
    VaiIcon["Moon"] = "moon";
    VaiIcon["MoonO"] = "moon-o";
    VaiIcon["NetworkSignal0"] = "network-signal-0";
    VaiIcon["NetworkSignal1"] = "network-signal-1";
    VaiIcon["NetworkSignal2"] = "network-signal-2";
    VaiIcon["NetworkSignal3"] = "network-signal-3";
    VaiIcon["NetworkSignal4"] = "network-signal-4";
    VaiIcon["NetworkSignalNo"] = "network-signal-no";
    VaiIcon["Nomad2"] = "nomad-2";
    VaiIcon["Nomad3"] = "nomad-3";
    VaiIcon["Note"] = "note";
    VaiIcon["PanHand"] = "pan-hand";
    VaiIcon["Parameters"] = "parameters";
    VaiIcon["Paste"] = "paste";
    VaiIcon["Pause"] = "pause";
    VaiIcon["Phone"] = "phone";
    VaiIcon["Play"] = "play";
    VaiIcon["Plus"] = "plus";
    VaiIcon["Pressure"] = "pressure";
    VaiIcon["Print"] = "print";
    VaiIcon["Probe"] = "probe";
    VaiIcon["Radar"] = "radar";
    VaiIcon["RadiobuttonOff"] = "radiobutton-off";
    VaiIcon["RadiobuttonOn"] = "radiobutton-on";
    VaiIcon["Rain"] = "rain";
    VaiIcon["Redo"] = "redo";
    VaiIcon["Refresh"] = "refresh";
    VaiIcon["Required"] = "required";
    VaiIcon["Resize"] = "resize";
    VaiIcon["Rewind"] = "rewind";
    VaiIcon["Room"] = "room";
    VaiIcon["RoomSection"] = "room-section";
    VaiIcon["Runways"] = "runways";
    VaiIcon["Rws"] = "rws";
    VaiIcon["Save"] = "save";
    VaiIcon["Search"] = "search";
    VaiIcon["Send"] = "send";
    VaiIcon["Server"] = "server";
    VaiIcon["Settings"] = "settings";
    VaiIcon["SevereStorm"] = "severe-storm";
    VaiIcon["Shelf"] = "shelf";
    VaiIcon["Signal0"] = "signal-0";
    VaiIcon["Signal1"] = "signal-1";
    VaiIcon["Signal2"] = "signal-2";
    VaiIcon["Signal3"] = "signal-3";
    VaiIcon["Signal4"] = "signal-4";
    VaiIcon["Signal5"] = "signal-5";
    VaiIcon["SkipBack"] = "skip-back";
    VaiIcon["SkipForward"] = "skip-forward";
    VaiIcon["Slash"] = "slash";
    VaiIcon["Sleet"] = "sleet";
    VaiIcon["SmallScreen"] = "small-screen";
    VaiIcon["Sms"] = "sms";
    VaiIcon["SmsO"] = "sms-o";
    VaiIcon["Snapshot"] = "snapshot";
    VaiIcon["Snow"] = "snow";
    VaiIcon["SnowFlake"] = "snow-flake";
    VaiIcon["SoundOff"] = "sound-off";
    VaiIcon["Sound0"] = "sound-0";
    VaiIcon["Sound1"] = "sound-1";
    VaiIcon["Sound2"] = "sound-2";
    VaiIcon["Sound3"] = "sound-3";
    VaiIcon["SoundingBalloon"] = "sounding-balloon";
    VaiIcon["SpeechBubble"] = "speech-bubble";
    VaiIcon["SpeechBubbleO"] = "speech-bubble-o";
    VaiIcon["Square"] = "square";
    VaiIcon["SquareO"] = "square-o";
    VaiIcon["Star"] = "star";
    VaiIcon["Stop"] = "stop";
    VaiIcon["Sun"] = "sun";
    VaiIcon["Sunrise"] = "sunrise";
    VaiIcon["Sunset"] = "sunset";
    VaiIcon["SwitchOnOff"] = "switch-on-off";
    VaiIcon["Sync"] = "sync";
    VaiIcon["SyncError"] = "sync-error";
    VaiIcon["Terminal"] = "terminal";
    VaiIcon["Thermometer"] = "thermometer";
    VaiIcon["Thumbnails"] = "thumbnails";
    VaiIcon["Thunder"] = "thunder";
    VaiIcon["Timer"] = "timer";
    VaiIcon["Toolbox"] = "toolbox";
    VaiIcon["Tools"] = "tools";
    VaiIcon["Tour"] = "tour";
    VaiIcon["Trash"] = "trash";
    VaiIcon["TreeControl"] = "tree-control";
    VaiIcon["Triangle"] = "triangle";
    VaiIcon["TriangleDown"] = "triangle-down";
    VaiIcon["TriangleLeft"] = "triangle-left";
    VaiIcon["TriangleO"] = "triangle-o";
    VaiIcon["TriangleRight"] = "triangle-right";
    VaiIcon["TriangleUp"] = "triangle-up";
    VaiIcon["Triton"] = "triton";
    VaiIcon["Truck"] = "truck";
    VaiIcon["Turbine"] = "turbine";
    VaiIcon["Undo"] = "undo";
    VaiIcon["Unlink"] = "unlink";
    VaiIcon["Unlock"] = "unlock";
    VaiIcon["Upload"] = "upload";
    VaiIcon["Usb"] = "usb";
    VaiIcon["User"] = "user";
    VaiIcon["UserGroup"] = "user-group";
    VaiIcon["VaisalaLogo"] = "vaisala-logo";
    VaiIcon["VaisalaLogoLarge"] = "vaisala-logo-large";
    VaiIcon["VisibilityOn"] = "visibility-on";
    VaiIcon["VisibilityOff"] = "visibility-off";
    VaiIcon["VisualImpediments"] = "visual-impediments";
    VaiIcon["Warning"] = "warning";
    VaiIcon["WarningO"] = "warning-o";
    VaiIcon["Wind"] = "wind";
    VaiIcon["WindTower"] = "wind-tower";
    VaiIcon["WindowMaximize"] = "window-maximize";
    VaiIcon["WindowMinimize"] = "window-minimize";
    VaiIcon["Wrench"] = "wrench";
    VaiIcon["XweatherLogoHorizontal"] = "xweather-logo-horizontal";
    VaiIcon["XweatherLogoMain"] = "xweather-logo-main";
    VaiIcon["ZoomMapExtent"] = "zoom-map-extent";
})(VaiIcon || (VaiIcon = {}));
